import { db } from '../../common/config/Firebase';
import firebase from 'firebase/app';
import moment from 'moment';

/**
 * Fetches holidays for a specific date range
 * @param {Date} startDate - Start date
 * @param {Date} endDate - End date
 * @returns {Promise<Array>} - Array of holiday dates (timestamps)
 */
export const getHolidaysUseCase = async (startDate, endDate) => {
    try {
        const start = firebase.firestore.Timestamp.fromDate(moment(startDate).startOf('day').toDate());
        const end = firebase.firestore.Timestamp.fromDate(moment(endDate).endOf('day').toDate());

        const snapshot = await db
            .collection('holidays')
            .where('date', '>=', start)
            .where('date', '<=', end)
            .get();

        const holidays = [];
        snapshot.forEach(doc => {
            const data = doc.data();
            holidays.push({
                id: doc.id,
                date: data.date.toDate(), // Convert Firebase Timestamp to JS Date
                description: data.description || ''
            });
        });

        console.log(`Fetched ${holidays.length} holidays`);
        return holidays;
    } catch (error) {
        console.error('Error fetching holidays:', error);
        return []; // Return empty array on error to not break the UI
    }
};

/**
 * Adds a new holiday to the collection
 * @param {Object} holidayData - Holiday data
 * @param {Date} holidayData.date - Holiday date as JS Date
 * @param {string} holidayData.description - Holiday description
 * @returns {Promise<string>} - Created holiday ID
 */
export const addHolidayUseCase = async (holidayData) => {
    try {
        const docRef = await db.collection('holidays').add({
            date: firebase.firestore.Timestamp.fromDate(holidayData.date),
            description: holidayData.description || '',
            createdAt: firebase.firestore.Timestamp.now()
        });

        console.log('Holiday created with ID:', docRef.id);
        return docRef.id;
    } catch (error) {
        console.error('Error adding holiday:', error);
        throw error;
    }
};

/**
 * Checks if a specific date is a holiday
 * @param {number} timestamp - Date timestamp
 * @param {Array} holidays - Array of holiday objects
 * @returns {boolean} - True if the date is a holiday
 */
export const isHoliday = (timestamp, holidays) => {
    const dateStr = moment(timestamp).format('YYYY-MM-DD');
    return holidays.some(holiday => {
        const holidayStr = moment(holiday.date).format('YYYY-MM-DD');
        return holidayStr === dateStr;
    });
};
